function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
import { get as i } from "./get.js";
import { isDeepKey as f } from "../_internal/isDeepKey.js";
import { toKey as s } from "../_internal/toKey.js";
import { toPath as c } from "../util/toPath.js";
function o(r, e) {
  if (r == null) return !0;
  switch (_typeof(e)) {
    case "symbol":
    case "number":
    case "object":
      {
        if (Array.isArray(e)) return u(r, e);
        if (typeof e == "number" ? e = s(e) : _typeof(e) == "object" && (Object.is(e == null ? void 0 : e.valueOf(), -0) ? e = "-0" : e = String(e)), (r == null ? void 0 : r[e]) === void 0) return !0;
        try {
          return delete r[e], !0;
        } catch (_unused) {
          return !1;
        }
      }
    case "string":
      {
        if ((r == null ? void 0 : r[e]) === void 0 && f(e)) return u(r, c(e));
        try {
          return delete r[e], !0;
        } catch (_unused2) {
          return !1;
        }
      }
  }
}
function u(r, e) {
  var t = i(r, e.slice(0, -1), r),
    n = e[e.length - 1];
  if ((t == null ? void 0 : t[n]) === void 0) return !0;
  try {
    return delete t[n], !0;
  } catch (_unused3) {
    return !1;
  }
}
export { o as unset };